  <template>
    <v-navigation-drawer
    v-model="show"
    :clipped="$vuetify.breakpoint.lgAndUp"
    app
    right
    >
        <v-list
        subheader
        flat
        >
        <v-subheader>Search by Name/Phone Number</v-subheader>
            <v-list-item>
                <v-list-item-content class="pa-0">
                    <v-text-field
                        v-model="keyword"
                        light
                        label="Type Name"
                        @keyup.enter.native="submitSearch"
                        clearable
                        hide-details
                        >
 
                    </v-text-field>
                    <v-text-field
                        v-model="phone"
                        light
                        label="Type Phone Number"
                        @keyup.enter.native="submitSearch"
                        clearable
                        hide-details
                        >
 
                    </v-text-field>    
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="date"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="dateRangeText"
                            label="Date Range"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="dates" no-title scrollable range>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="rangeCancel">Cancel</v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                        </v-date-picker>
                    </v-menu>              
                    <v-btn
                        depressed 
                        tile
                        color="primary"
                        class="mx-0 mb-0 mt-2"
                        @click.prevent="submitSearch">
                    
                        <v-icon>mdi-magnify</v-icon>
                        Search
                    </v-btn>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="routekey != 'new'"
        >
        <v-subheader>Filter by Status</v-subheader>
            <v-list-item >
                <v-list-item-content>
                    <v-radio-group v-model="status" class="mt-0">
                        <v-radio
                            v-for="(item, index) in statuses" 
                            :key="`status-${index}`"
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="routekey != 'new'"
        >
        <v-subheader>Filter by Assign/Unassigned</v-subheader>
            <v-list-item>
                <v-list-item-content>
                    <v-radio-group v-model="assign" class="mt-0">
                        <v-radio
                            v-for="(item, index) in assignitems"
                            :key="`assign-${index}`"
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="routekey != 'new'"
        >
        <v-subheader>Filter by Scheduled/Unscheduled</v-subheader>
            <v-list-item>
                <v-list-item-content>
                    <v-radio-group v-model="schedule" class="mt-0">
                        <v-radio
                            v-for="(item, index) in schedules" 
                            :key="`schedule-${index}`"
                            color="primary"
                            :value="item.value"
                            :label="item.label"
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-list
        subheader
        flat
        v-if="routekey != 'my' && routekey != 'new'"
        >
        <v-subheader>By Estimator</v-subheader>
            <v-list-item>
                <v-list-item-content>
                    <v-radio-group v-model="estimator" class="mt-0">
                        <v-radio
                            color="primary"
                            value="all"
                            label="All"
                        ></v-radio>
                        <v-radio
                            v-for="(estimator, index) in estimators" 
                            :key="`estimator-${index}`"
                            color="primary"
                            :value="estimator.id"     
                            :label="estimator.name"                       
                        ></v-radio>
                    </v-radio-group>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['show', 'filter', 'routekey'],
  data: () => ({
    schedule: "",
    status: "",
    estimator: "",
    assign: "",
    keyword: "",
    phone: "",
    dates: [],
    menu: false,
  }),
  computed: {
      ...mapGetters({
          estimators: 'data/estimators',
          statuses: 'data/statusArray',
          schedules: 'data/schedulesArray',
          assignitems: 'data/assignArray'
      }),
      dateRangeText () {
          if(this.dates.length == 2) {
            if(this.dates[0] > this.dates[1]) {
                return this.dates[1] + '/' + this.dates[0]
            } else {
                return this.dates[0] + '/' + this.dates[1] 
            }
          } else {
              return this.dates[0]
          }
      },
  },
  created() {
      this.schedule = this.filter.schedule
      this.status = this.filter.status
      this.estimator = this.filter.estimator
      this.assign = this.filter.assign,
      this.keyword = this.filter.keyword
      this.phone = this.filter.phone
  },
  watch: {
    show(newVal) { // watch it
        this.$emit('update-drawer', newVal)
    },
    schedule(newVal) { // watch it
        this.$emit('update-schedule', newVal)
    },
    estimator(newVal) { // watch it
        this.$emit('update-estimator', newVal)
    },
    status(newVal) { // watch it
        this.$emit('update-status', newVal)
    },
    assign(newVal) { // watch it
        this.$emit('update-assign', newVal)
    },
    keyword(newVal) {
        this.$emit('update-keyword', newVal)
    },
    dateRangeText(newVal) {
        this.$emit('update-daterange', newVal)
    },
    phone(newVal) {
        this.$emit('update-phone', newVal)
    }
  },
  methods: {
    submitSearch() {
        this.$emit('submit-search')
    },
    rangeCancel() {
        this.menu = false
        this.dates = []
    }
  }
}
</script>